import {
    CloseCircleOutlined,
    DeleteOutlined,
    EditFilled,
    MoreOutlined,
    SaveFilled,
  } from "@ant-design/icons";
  import {
    Box,
    Dialog,
    DialogContent,
    IconButton,
    Menu,
    MenuItem,
    TextField,
    Typography,Button
  } from "@mui/material";

  import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
  import { DatePicker } from "@mui/x-date-pickers/DatePicker";
  import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
  import dayjs from "dayjs";

  import { useRef, useState } from "react";
  import { useNotification } from "../../../hooks/useNotification.js";
  import { JournalAPIService } from "../../../services/api/JournalAPIService";
  import { API_ERROR_MESSAGE, API_SUCCESS_MESSAGE, DATE } from "../../../shared/constants";
  import ConfirmationDialog from "../../common/ConfirmationDialog.js";
import ActionMenu from "../../../pages/Extra/ActionMenu.js";
import html2canvas from "html2canvas";
import DownloadBackdrop from "../../../pages/Memory_journal/DownloadBackdrop.js";


  export default function CardTemplateEdit({
    journalId,
    author,
    headingText,
    bodyText,
    date,
    bgColor = "#007aff",
    headingColor = "#ff92ac",
    textColor = "#ffffff",
    borderColor = "pink",
    imageTopLeft,
    imageTopLeftStyle,
    imageTopRight,
    imageTopRightStyle,
    imageBottomLeft,
    imageBottomLeftStyle,
    imageBottomRight,
    imageBottomRightStyle,
    disableEye = false,
    editData = false,
    open,
    onClose,
    pageRefreshCallback
  }) {
    const cardRef = useRef(null);
    const { notifyError, notifySuccess } = useNotification();

    const [showEye, setShowEye] = useState(false);
    const [editMode, setEditOpen] = useState(editData);
    const [editableDate, setEditableDate] = useState(dayjs(date));
    const [editableHeading, setEditableHeadingText] = useState(headingText);
    const [editableBodyText, setEditableBodyText] = useState(bodyText);
    const [anchorEl, setAnchorEl] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [downloading, setDownloading] = useState(false);

    const openMenu = Boolean(anchorEl);

    const handleMenuClick = (action) => {
      switch (action) {
        case "edit":
          handleEdit();
          break;
        case "delete":
          handleDelete();
          break;
        case "effect":
          // handleOpenEditor(imgSrc, journalId);
          break;
        case "save":
          handleDownloadImage();
          break;
        case "drag":

          console.log("Drag action triggered");
          // Optional: set some dragging state here
          break;
        default:
          break;
      }
    };

    const handleMenuClose = () => {
      setAnchorEl(null);
      setShowEye(false);
    };

    const handleCloseDialog = () => {
      onClose();
      setEditOpen(false);
      setShowEye(false);
    };

    const handleEdit = () => {
      setShowEye(false);
      setEditOpen(true);
    };

    const handleSubmit = () => {
      handleCloseDialog();
    };

    const handleDelete = () => {
      setConfirmDialogOpen(true);
    };

    const handleCancelDelete = () => {
      setConfirmDialogOpen(false);
    };

    const handleConfirmDelete = () => {
      setConfirmDialogOpen(false);

      JournalAPIService.journalDelete(journalId)
        .then((response) => {
          notifySuccess(response.message || API_SUCCESS_MESSAGE.DELETED_SUCCESSFULLY);
          pageRefreshCallback();
        })
        .catch((errResponse) => {
          notifyError(
            errResponse?.response?.data?.message || API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR
          );
        });

      handleCloseDialog();
    };

    const handleUpdate = () => {
      JournalAPIService.journalUpdate(journalId, {
        posted_at: dayjs(editableDate).toISOString(),
        media_caption: editableBodyText,
        tagline: editableHeading,
        author,
      })
        .then((response) => {
          notifySuccess(API_SUCCESS_MESSAGE.UPDATED_SCUCESSFULLY);
          pageRefreshCallback();
        })
        .catch((errResponse) => {
          notifyError(
            errResponse?.response?.data?.message || API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR
          );
        });

      handleCloseDialog();
    };

    const handleDownloadImage = async () => {
      if (!cardRef.current) return;

      try {
        setDownloading(true);

        const canvas = await html2canvas(cardRef.current, {
          useCORS: true,
          backgroundColor: null,
          // scale: 2,
          allowTaint: true,
          logging: false,
          removeContainer: true,
          imageTimeout: 15000,
        });

        const hashCode = (str) => {
          let hash = 0;
          for (let i = 0; i < str.length; i++) {
            hash = (hash << 5) - hash + str.charCodeAt(i);
            hash |= 0;
          }
          return Math.abs(hash % 10000);
        };

        const shortCode = hashCode(journalId);

        const dataUrl = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = `IMG_${shortCode}.png`;
        link.click();
        notifySuccess(API_SUCCESS_MESSAGE.DOWNLOAD_REEL);
      } catch (error) {
        console.error("Download failed:", error);
      } finally {
        setDownloading(false);
      }
    };

    return (
      <>


        {/* Dialog */}
        <Dialog open={open} onClose={handleCloseDialog} fullWidth maxWidth="sm">
          <DialogContent
            sx={{ position: "relative", p: 2, height: { xs: "380px", sm: "400px", md: "400px" } }}
          >
            {editMode ? (
             <Button
             variant="contained"
             onClick={handleUpdate}
             sx={{
               position: "absolute",
               top: 4,
               right: 4,
               zIndex: 10000,
               marginTop: "2px",
               // marginBottom: "1px",
               // margin: "0 16px 0 0",
               fontSize: "0.5rem",
               color:"#ffff",
               background:"#005cff",
               fontFamily:"Poppins",
               textTransform:"none",
               // borderRadius: "24px",
             }}
           >
             Save and Close
           </Button>
            ) : (
              <IconButton
                onClick={handleCloseDialog}
                sx={{ position: "absolute", top: 2, right: 2, zIndex: 10000 }}
              >
                <CloseCircleOutlined />
              </IconButton>
            )}

<IconButton
                          sx={{
                            position: "absolute",
                            top: 60,
                            right: 130,
                            color: "black",
                            zIndex: 1001,
                            width: { xs: "25px", sm: "30px", md: "30px" },
                            height: { xs: "25px", sm: "30px", md: "30px" },
                            "@media (max-width: 440px)": {
                              height: "20px",
                              width: "20px",
                              top:56,
                              right:30
                            },
                            "@media (min-width: 441px) and (max-width: 600px)": {
                              height: "24px",
                              width: "24px",
                              top: 80,
                              right: 40,
                            }
                            // bgcolor: "#ffffffc9",
                          }}
                          // onClick={handleMenuClick}
                        >
                   <ActionMenu action={handleMenuClick} show={true} drag={false} edit={editMode} fullView={false}/>
                    </IconButton>

<Box
          ref={cardRef}
          sx={{
            width: {
              xs: disableEye ? "90%" : "100%",
              sm: disableEye ? "60%" : "100%",
              md: disableEye ? "60%" : "100%",
            },
            height: { xs: 300, sm: 320, md: 320 },
            "@media (max-width: 370px)": {
              height: 300,
            },
            marginTop: {
              xs: disableEye ? "10%" : "0%",
              sm: disableEye ? "6%" : "0%",
              md: disableEye ? "6%" : "0%",
            },
            bgcolor: bgColor,
            borderRadius: "16px",
            border: `4px solid ${borderColor}`,
            color: textColor,
            p: "10px",
            position: "relative",
            overflow: "hidden",
            textAlign: "center",
            justifySelf: "center",
            fontFamily: "Arial, sans-serif",
          }}
          onMouseEnter={() => setShowEye(true)}
          onMouseLeave={() => setShowEye(false)}
        >



          {/* Dynamic Images */}
          {imageTopLeft && (
            <Box
              component="img"
              src={imageTopLeft}
              alt="top-left"
              sx={{
                position: "absolute",
                ...imageTopLeftStyle,
              }}
            />
          )}

          {imageTopRight && (
            <Box
              component="img"
              src={imageTopRight}
              alt="top-right"
              sx={{
                position: "absolute",
                ...imageTopRightStyle,
              }}
            />
          )}

          {imageBottomLeft && (
            <Box
              component="img"
              src={imageBottomLeft}
              alt="bottom-left"
              sx={{
                position: "absolute",
                ...imageBottomLeftStyle,
              }}
            />
          )}

          {imageBottomRight && (
            <Box
              component="img"
              src={imageBottomRight}
              alt="bottom-right"
              sx={{
                position: "absolute",
                borderRadius: "50%",
                ...imageBottomRightStyle,
              }}
            />
          )}
          <Box
            sx={{
              height:"230px",
              alignContent:"center",
              mt: editMode ? "0%": bodyText?.length < 150 ? bodyText?.length < 80 ? "14%" : "14%" : "14%",
              "@media (min-width: 400px) and (max-width: 800px)": {
                mt: editMode ? "0%": bodyText?.length < 150 ? bodyText?.length < 80 ? "14%" : "14%" : "14%",
          },
          "@media (max-width: 370px)": {
                mt: editMode ? "0%": bodyText?.length < 150 ? bodyText?.length < 80 ? "14%" : "14%" : "14%",
          },

              alignSelf:
                bodyText?.length < 150 || editMode || disableEye ? "center" : "stretch",
              // position:
              //   bodyText?.length < 150 || editMode || disableEye
              //     ? "absolute"
              //     : "relative",
              width:
                bodyText?.length < 150 || editMode || disableEye ? "100%" : "100%",
          }}
          >
            {/* Heading */}
            {editMode ? (
              <TextField
                id="outlined-basic"
                label=""
                variant="outlined"
                multiline
                rows={2}
                value={editableHeading}
                onChange={(e) => setEditableHeadingText(e.target.value)}
                sx={{
                  width: "100%",
                  marginTop: "10%",
                  "& .MuiInputBase-inputMultiline": {
                    textAlign: "center", // horizontal center
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  },

                }}
                InputProps={{
                  sx: {
                    color: headingColor,
                    fontSize: { xs: "0.8rem", sm: "1rem", md: "1rem" },
                  },
                }}
              />
            ) : (
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: bodyText?.length < 150 || editMode || disableEye  ? "0.8rem" : "0.8rem", sm: "1rem", md: "1rem" },
                  mb: 2,
                  color: headingColor,
                }}
              >
                {headingText}
              </Typography>
            )}

            {editMode ? (
              <TextField
                id="outlined-basic"
                label=""
                variant="outlined"
                multiline
                rows={4}
                value={editableBodyText}
                onChange={(e) => setEditableBodyText(e.target.value)}
                sx={{
                  width: "100%",
                  marginTop: "2%",
                }}
                InputProps={{
                  sx: {
                    color: textColor,
                    fontSize: { xs: "0.9rem", sm: "1rem", md: "1rem" },
                  },
                }}
              />
            ) : (
              <Typography
                sx={{
                  fontSize: { xs: bodyText?.length < 150 || editMode || disableEye ? "0.8rem" : "0.7rem", sm: "1rem", md: "1rem" },
                  color: textColor,
                  lineHeight: 1.6,
                }}
              >
                {bodyText}
              </Typography>
            )}
          </Box>

          {/* Date */}
          {editMode ? (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={dayjs(editableDate)}
                onChange={(newValue) => setEditableDate(newValue)}
                format={DATE.JOURNAL_FORMAT}
                sx={{
                  position: "absolute",
                  bottom: 0,
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: 160,
                  "& .MuiInputBase-input": {
                    textAlign: "center",
                    padding: "5px",
                    fontSize: { xs: "0.7rem", sm: "0.8rem", md: "0.8rem" },
                    color: textColor,
                  },
                }}
              />
            </LocalizationProvider>
          ) : (
            <Typography
              sx={{
                position: "absolute",
                bottom: 4,
                left: "50%",
                transform: "translateX(-50%)",
                fontSize: { xs: "0.8rem", sm: "0.9rem", md: "0.9rem" },
                color: textColor,
              }}
            >
              {dayjs(date).format(DATE.JOURNAL_FORMAT)}
            </Typography>
          )}
        </Box>

        <ConfirmationDialog
          id="confirmation-dialog-description"
          open={confirmDialogOpen}
          title=""
          description="Are you sure you want to delete this memory?"
          onConfirm={handleConfirmDelete}
          onCancel={handleCancelDelete}
          confirmText="Delete"
          cancelText="Cancel"
          keepMounted={false}
          transition="up"
          loading={false}
        />
          </DialogContent>
        </Dialog>

      <DownloadBackdrop downloading={downloading} />

      </>
    );
  }
